import airtableJson from 'airtable-json';

//FixMe: исправить загрузку товаров


const getAirtableData = async () => {

    const auth_key = "patOP5d7zFd9Fe7wl.06ae65686d3f84a617db94f78ea9f80c1349c5f75ec1dbd383e47f6761f72d8f"
    const base_name = 'appi4VPMoNfY1TJwg'
    const pizzaData = await airtableJson({
        auth_key, // это ваш ключ API Airtable, начинающийся с 'key'
        base_name, // это ключ API базы, который начинается с 'app'
        primary: "Product", // это имя таблицы, которую вы хотите получить
        view: "product" // это представление, которое вы хотите получить
    });


     return pizzaData;
};




export default getAirtableData;